import { useSetRecoilState } from "recoil";
import { jobsAtom } from "../miscellaneous/jobsAtom";

export const useSetJobsState = () => {
  return useSetRecoilState(jobsAtom);
};
